// Диплинк на КОНКРЕТНУЮ партию: payload для Telegram `startapp` (лимит 64 символа,
// алфавит [A-Za-z0-9_-]). Формат `<code>_<nick>_<id>`, где code = l|c (lichess|chess.com).
// Ники lichess/chess.com уже [a-z0-9_-], id — [A-Za-z0-9-] (lichess 8 алфанум,
// chess.com UUID с дефисами; `_` в id не бывает), поэтому кодировать
// нечего: парсинг снимает id по ПОСЛЕДНЕМУ `_` (в id `_` не бывает), остальное — ник.
// Чистый модуль без DOM/сети — покрыт юнит-тестами (round-trip, лимит, битый ввод).

export type DeeplinkSite = 'lichess' | 'chesscom';

export interface DeeplinkRef {
  site: DeeplinkSite;
  nick: string;
  id: string;
}

/** Максимальная длина start_param в Telegram. */
export const MAX_PAYLOAD_LEN = 64;

const SAFE = /^[A-Za-z0-9_-]+$/;
// id по краю (без `_`) + ник как «всё до последнего `_`» — снимает неоднозначность,
// когда ник сам содержит `_`/`-`.
const PARSE = /^([lc])_(.+)_([A-Za-z0-9-]+)$/;

/**
 * Собрать payload. Возвращает null, если ник/id пустые, содержат недопустимые
 * символы или итог длиннее лимита Telegram — вызывающий деградирует в общую ссылку.
 */
export function buildDeeplinkPayload(site: DeeplinkSite, nick: string, id: string): string | null {
  if (!nick || !id) return null;
  const code = site === 'lichess' ? 'l' : 'c';
  const payload = `${code}_${nick}_${id}`;
  if (payload.length > MAX_PAYLOAD_LEN) return null;
  if (!SAFE.test(payload) || !SAFE.test(nick) || !/^[A-Za-z0-9-]+$/.test(id)) return null;
  return payload;
}

/** Разобрать payload обратно в ссылку на партию. null — параметр битый/пустой. */
export function parseDeeplinkPayload(payload: string | null | undefined): DeeplinkRef | null {
  if (!payload || payload.length > MAX_PAYLOAD_LEN || !SAFE.test(payload)) return null;
  const m = PARSE.exec(payload);
  if (!m) return null;
  const nick = m[2]!;
  const id = m[3]!;
  if (!nick || !id) return null;
  return { site: m[1] === 'l' ? 'lichess' : 'chesscom', nick, id };
}
